export const GST_TYPES = {
    REGULAR: 'Regular GST',
    COMPOSITION: 'Composition GST',
    UNREGISTERED: 'Unregistered',
};

export const INDIAN_STATES = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',
    'Andaman and Nicobar Islands',
    'Chandigarh',
    'Dadra and Nagar Haveli and Daman and Diu',
    'Delhi',
    'Jammu and Kashmir',
    'Ladakh',
    'Lakshadweep',
    'Puducherry',
];

export const INITIAL_SELLER = {
    name: '',
    gstNumber: '',
    address: '',
    state: '',
};

export const INITIAL_BUYER = {
    name: '',
    gstNumber: '',
    address: '',
    state: '',
};

export const ITEM_TYPES = {
    GOODS: 'GOODS',
    SERVICE: 'SERVICE',
};

export const INITIAL_PRODUCT = {
    id: '', // uuid
    name: '',
    type: ITEM_TYPES.GOODS,
    hsnCode: '',
    rate: 0,
    quantity: 1,
    gstRate: 18, // Default 18%
};

// Simple State Code extraction (First 2 digits of GST)
export const getStateCode = (gstNumber) => {
    if (!gstNumber || gstNumber.length < 2) return '';
    return gstNumber.substring(0, 2);
};
